(() => {
  const menus = [...document.querySelectorAll('.dag-site-header .truck-menu')];
  document.addEventListener('click', event => {
    menus.forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = menus.find(menu => menu.open && menu.contains(document.activeElement));
    menus.forEach(menu => { menu.open = false; });
    active?.querySelector('summary').focus();
  });
  menus.forEach(menu => {
    let closeTimer;
    const hover = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 601px)');
    menu.addEventListener('pointerenter', event => {
      if (!hover.matches || event.pointerType === 'touch') return;
      clearTimeout(closeTimer);
      menus.forEach(other => { if (other !== menu) other.open = false; });
      menu.open = true;
    });
    menu.addEventListener('pointerleave', () => {
      if (!hover.matches) return;
      closeTimer = setTimeout(() => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      }, 180);
    });
    menu.addEventListener('toggle', () => {
      if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
    });
    menu.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      });
    });
  });
})();